var map = {
	"./fire1.png": "db0d1",
	"./fire10.png": "4635",
	"./fire2.png": "246b",
	"./fire3.png": "7ec4",
	"./fire4.png": "bfc8",
	"./fire5.png": "a09a",
	"./fire6.png": "7536",
	"./fire7.png": "687a",
	"./fire8.png": "f367",
	"./fire9.png": "870e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79c0";